import HttpResponse from "../../../../../utils/http/http.response";

export type BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContractTaxiDetails =
  {
    id: string;
    displayName: string;
  };

export enum BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContract = {
  model: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxi: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContractTaxiDetails;
  consumerTaxi: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContractTaxiDetails;
};

export type BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionTransportingOrder =
  {
    cargoOrder: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionTransportingOrderCargoOrder;
  };

export type BillingsTaxiTaxiDetailsResponseDataOrderForwardingAction = {
  id: string;
  contract: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionContract;
  transportingOrder: BillingsTaxiTaxiDetailsResponseDataOrderForwardingActionTransportingOrder;
};

export type BillingsTaxiTaxiDetailsResponseDataNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date;
  checkoutEventId: string | null;
  plannedDate: Date;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  haltingAmount: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiTaxiDetailsResponseDataContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiTaxiDetailsResponseDataContributionBonusFavorableDistance =
  {
    type: BillingsTaxiTaxiDetailsResponseDataContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsTaxiTaxiDetailsResponseDataContributionBonusOther = {
  type: BillingsTaxiTaxiDetailsResponseDataContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsResponseDataContributionPenaltyWrongRoute = {
  type: BillingsTaxiTaxiDetailsResponseDataContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsResponseDataContributionPenaltyBeingLate = {
  type: BillingsTaxiTaxiDetailsResponseDataContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsResponseDataContributionPenaltyIncompatibleCar =
  {
    type: BillingsTaxiTaxiDetailsResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsTaxiTaxiDetailsResponseDataContributionPenaltyOther = {
  type: BillingsTaxiTaxiDetailsResponseDataContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsResponseDataContributionBonus =
  | BillingsTaxiTaxiDetailsResponseDataContributionBonusFavorableDistance
  | BillingsTaxiTaxiDetailsResponseDataContributionBonusOther;

export type BillingsTaxiTaxiDetailsResponseDataContributionPenalty =
  | BillingsTaxiTaxiDetailsResponseDataContributionPenaltyWrongRoute
  | BillingsTaxiTaxiDetailsResponseDataContributionPenaltyBeingLate
  | BillingsTaxiTaxiDetailsResponseDataContributionPenaltyIncompatibleCar
  | BillingsTaxiTaxiDetailsResponseDataContributionPenaltyOther;

export type BillingsTaxiTaxiDetailsResponseDataContribution =
  | BillingsTaxiTaxiDetailsResponseDataContributionBonus
  | BillingsTaxiTaxiDetailsResponseDataContributionPenalty;

export enum BillingsTaxiTaxiDetailsResponseDataStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsTaxiTaxiDetailsResponseData = {
  orderForwardingAction: BillingsTaxiTaxiDetailsResponseDataOrderForwardingAction;
  billingNodes: BillingsTaxiTaxiDetailsResponseDataNode[];
  billingContributions: BillingsTaxiTaxiDetailsResponseDataContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryId: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  status: BillingsTaxiTaxiDetailsResponseDataStatus;
  passengers: string[];
};

type BillingsTaxiTaxiDetailsResponse =
  HttpResponse<BillingsTaxiTaxiDetailsResponseData>;

export default BillingsTaxiTaxiDetailsResponse;
